module.exports = __webpack_public_path__ + "static/media/delete-popup.c242d6f2.svg";